import { Box, Table, Tbody, Td, Text, Th, Thead, Tr, Flex, Menu, MenuList, MenuItem, MenuButton } from '@chakra-ui/react';
import { flexRender, getCoreRowModel, getSortedRowModel, useReactTable, createColumnHelper } from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import { IconButton } from '@chakra-ui/react';
import isEmpty from 'lodash/isEmpty';
import { ViewIcon } from '@chakra-ui/icons';
import { FORMAT_DATE, ModalType } from 'constants/common';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FaHistory } from 'react-icons/fa';
import { ImCoinDollar } from 'react-icons/im';
import moment from 'moment';
import AuthorizationComponentWrapper from 'components/AuthorizationComponentWrapper/AuthorizationComponentWrapper';
import { useUserState } from 'context/UserContext';

const SizeTable = ({ categorysData, handleUpdateCategory, refetch, handleShowMemberDetail }) => {
  const [sorting, setSorting] = useState([]);
  const columnHelper = createColumnHelper();
  const history = useHistory();
  const { userInfo } = useUserState();

  // const handleRowClick = (ticket, type) => {
  //   handleUpdateCategory(ticket, type);
  // };

  const handleViewClick = (idMember, ModalType) => {
    handleShowMemberDetail(idMember, ModalType);
  };

  const columns = useMemo(
    () => [
      columnHelper.accessor('username', {
        header: 'Tên tài khoản',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('phone', {
        header: 'Số điện thoại',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('brand', {
        header: 'Nhà cái',
        cell: info => info.getValue() || '--',
      }),
      columnHelper.accessor('level', {
        header: 'Cấp độ (Nhà cái)',
        cell: info => info.getValue() || '--',
      }),
      columnHelper.accessor('kkLevel', {
        header: 'Cấp độ HTTĐ',
        cell: info => info.getValue() || '--',
      }),
      columnHelper.accessor('coin', {
        header: 'Xu',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('createdAt', {
        header: 'Thời gian tham gia',
        cell: info => moment(info.getValue()).format(FORMAT_DATE),
      }),
      columnHelper.accessor('action', {
        header: 'Thao tác',
        cell: info => (
          <Flex alignItems="center" margin={'auto'}>
            <AuthorizationComponentWrapper groupPermission={userInfo?.permissions} groupName={'VIEW_DETAIL_MEMBER'}>
              <IconButton bg="transparent" onClick={() => handleViewClick(info?.row?.original?._id, ModalType.Preview)}>
                <ViewIcon cursor="pointer" boxSize={4} />
              </IconButton>
            </AuthorizationComponentWrapper>
            <AuthorizationComponentWrapper groupPermission={userInfo?.permissions} groupName={'ADD_SUBTRACT_COIN_MEMBER'}>
              <IconButton bg="transparent" onClick={() => handleViewClick(info?.row?.original?._id, ModalType.Adjust)}>
                <ImCoinDollar cursor="pointer" boxSize={4} />
              </IconButton>
            </AuthorizationComponentWrapper>
            <Menu>
              {({ isOpen }) => (
                <>
                  <MenuButton bg="transparent" isActive={isOpen} as={IconButton}>
                    <IconButton bg="transparent" onClick={() => handleViewClick(info?.row?.original?._id, ModalType.Block)}>
                      <FaHistory cursor="pointer" boxSize={4} />
                    </IconButton>
                  </MenuButton>
                  <MenuList>
                    <AuthorizationComponentWrapper groupPermission={userInfo?.permissions} groupName={'VIEW_HISTORY_RECHARGE_BET_MEMBER'}>
                      <MenuItem
                        onClick={() => {
                          history.push(`/admin/members/${info?.row?.original?._id}/histories`);
                        }}
                      >
                        Lịch sử nạp, cược
                      </MenuItem>
                    </AuthorizationComponentWrapper>
                    <AuthorizationComponentWrapper groupPermission={userInfo?.permissions} groupName={'VIEW_HISTORY_COLLECT_COIN_MEMBER'}>
                      <MenuItem
                        onClick={() => {
                          history.push(`/admin/members/${info?.row?.original?._id}/missions`);
                        }}
                      >
                        Lịch sử nhận xu
                      </MenuItem>
                    </AuthorizationComponentWrapper>
                    <AuthorizationComponentWrapper groupPermission={userInfo?.permissions} groupName={'VIEW_HISTORY_ORDER_MEMBER'}>
                      <MenuItem onClick={() => handleViewClick(info?.row?.original?._id, ModalType.Block)}>Lịch sử mua đổi hàng</MenuItem>
                    </AuthorizationComponentWrapper>
                    <AuthorizationComponentWrapper groupPermission={userInfo?.permissions} groupName={'VIEW_ADDRESS_MEMBER'}>
                      <MenuItem onClick={() => handleViewClick(info?.row?.original?._id, ModalType.Detail)}>
                        Thông tin địa chỉ nhận hàng
                      </MenuItem>
                    </AuthorizationComponentWrapper>
                  </MenuList>
                </>
              )}
            </Menu>
          </Flex>
        ),
      }),
    ],
    [categorysData]
  );

  const table = useReactTable({
    data: categorysData || [],
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  return (
    <Table>
      <Thead>
        {table.getHeaderGroups().map(headerGroup => (
          <Tr key={headerGroup.id}>
            {headerGroup.headers.map(header => (
              <Th key={header.id} w="120px">
                {header.isPlaceholder ? null : (
                  <Box
                    isTruncated
                    cursor={header.column.getCanSort() ? 'pointer' : 'default'}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                    {{
                      asc: ' 🔼',
                      desc: ' 🔽',
                    }[header.column.getIsSorted()] ?? null}
                  </Box>
                )}
              </Th>
            ))}
          </Tr>
        ))}
      </Thead>
      <Tbody>
        {isEmpty(table.getRowModel().rows) ? (
          <Tr>
            <Td textAlign="center" colSpan={6}>
              Không có dữ liệu
            </Td>
          </Tr>
        ) : (
          table.getRowModel().rows.map(row => (
            <Tr key={row.id}>
              {row.getVisibleCells().map(cell => (
                <Td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>
              ))}
            </Tr>
          ))
        )}
      </Tbody>
    </Table>
  );
};

export default SizeTable;
